import { Box, Typography } from "@mui/material";
import { Track } from "../../types";
import LinkedTracksEmptyState from "./empty-state";
import { useLinkedTracksQuery } from "../../hooks/linked-tracks.hook";
import AddNewTrack from "./add-new-track";
import TrackCard from "./track-card/index.tsx";
import LoadingSkeleton from "@/modules/common/components/ui/loadingSkeleton.tsx";

export default function LinkedTracksTab({ track }: { track: Track }) {
  const { data: linkedTracks, isLoading } = useLinkedTracksQuery({
    uid: track.uid,
  });

  const hasLinkedtracks = linkedTracks && linkedTracks.length > 0;

  if (isLoading) return <LoadingSkeleton heights={["100"]} rows={3} />;

  return (
    <Box
      sx={{
        height: "100%",
      }}
    >
      {hasLinkedtracks ? (
        <>
          <Box
            sx={(theme) => ({
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: theme.nawy.colors.semantic.layer.primary,
              p: theme.nawy.spacing.md,
              borderRadius: theme.nawy.radius.xl,
            })}
          >
            <Box
              sx={(theme) => ({
                display: "flex",
                alignItems: "baseline",
                gap: theme.nawy.spacing.xxs,
              })}
            >
              <Typography
                sx={(theme) =>
                  theme.nawy.typography.english.variants.headline.sm
                }
              >
                Linked Tracks
              </Typography>
              <Typography
                sx={(theme) =>
                  theme.nawy.typography.english.variants.body.sm.regular
                }
              >
                ({linkedTracks?.length ?? 0})
              </Typography>
            </Box>
            <AddNewTrack track={track} />
          </Box>

          <Box
            sx={(theme) => ({
              display: "flex",
              flexDirection: "column",
              gap: theme.nawy.spacing.md,
              py: theme.nawy.spacing.md,
            })}
          >
            {linkedTracks.map((track) => (
              <TrackCard track={track} />
            ))}
          </Box>
        </>
      ) : (
        <LinkedTracksEmptyState track={track} />
      )}
    </Box>
  );
}
